import AuthenticationService from "./AuthenticationService";

export class AuthenticationServiceFactory {
  private static instance?: AuthenticationService;

  public static getInstance(): AuthenticationService {
    if (AuthenticationServiceFactory.instance === undefined) {
      AuthenticationServiceFactory.instance = new AuthenticationService();
    }
    return AuthenticationServiceFactory.instance;
  }
}

export default AuthenticationServiceFactory;
